const config = {
  development: {
    APP_VER_NUM: 1,
    APP_VER: '1.0.0',
    API_HOST: 'http://testoss.yuntuiov.com:8080/web-service',
    OSS_KEY_SECRET: '',
    OSS_KEY_ID: '',
    OSS_ENDPOINT: '',
    OSS_BUCKET: '',
    OSS_HOST: '',
    AMAP_KEY: '48e70d77f0ce49542efa775fc2689f64',
  },
  productionDev: {
    APP_VER_NUM: 1,
    APP_VER: '1.0.0',
    API_HOST: 'http://testoss.yuntuiov.com:8080/web-service',
    OSS_KEY_SECRET: '',
    OSS_KEY_ID: '',
    OSS_ENDPOINT: '',
    OSS_BUCKET: '',
    OSS_HOST: '',
    AMAP_KEY: '48e70d77f0ce49542efa775fc2689f64',
  },
  production: {
    APP_VER_NUM: 1,
    APP_VER: '1.0.0',
    API_HOST: 'http://api.web.yuntuiov.com/web-service',
    OSS_KEY_SECRET: '',
    OSS_KEY_ID: '',
    OSS_ENDPOINT: '',
    OSS_BUCKET: '',
    OSS_HOST: '',
    AMAP_KEY: '48e70d77f0ce49542efa775fc2689f64',
  },
};
const pro = config[process.env.CONFIG_ENV || 'development'];
export default pro;
